import React from 'react';
import { formatPrice } from '../../utils/formatPrice';
import Button from '../common/Button';
import ProductThumbnail from '../product/ProductThumbnail';
import { useLanguage } from '../../context/LanguageContext';
import {
  getBasePrice,
  getDisplayPrice,
  getSalePercentage,
  productHasSale,
} from '../../utils/productPricing';

const QUANTITY_BUTTON_STYLE = {
  width: '44px',
  height: '44px',
  border: '1px solid #bf57ea',
  borderRadius: '6px',
  backgroundColor: '#bf57ea',
  color: '#fff',
  cursor: 'pointer',
  fontSize: '18px',
  fontWeight: 700,
};

const REMOVE_BUTTON_STYLE = {
  backgroundColor: '#e34949',
  color: '#fff',
  border: '1px solid #e34949',
};

const getSpecialCode = (item) => (
  item.specialCode ||
  item.product?.specialCode ||
  item.productCode ||
  item.product?.productCode ||
  item.code ||
  item.product?.code ||
  ''
);

const CartItem = ({ item, onUpdateQuantity, onRemove }) => {
  const { t } = useLanguage();
  const product = item.product || item;
  const productName = product.title || product.name || t('common.product');
  const productPrice = getDisplayPrice(product);
  const originalPrice = getBasePrice(product);
  const salePercentage = getSalePercentage(product);
  const hasSale = productHasSale(product);
  const prescription = item.selectedPrescription || item.prescription || item.product?.selectedPrescription || item.product?.prescription;
  const specialCode = getSpecialCode(item);
  const quantity = item.quantity || 1;
  const itemTotal = productPrice * quantity;

  return (
    <div className="cart-line">
      <ProductThumbnail product={item.product || item} size="cart" />
      <div className="cart-line__content">
        <h3>{productName}</h3>
        {prescription && (
          <p style={{ color: '#666', fontSize: '13px', fontWeight: 700, margin: '4px 0' }}>
            {t('product.prescription')}: {prescription}
          </p>
        )}
        {specialCode && (
          <p style={{ color: '#666', fontSize: '13px', fontWeight: 700, margin: '4px 0' }}>
            {t('product.specialCode')}: {specialCode}
          </p>
        )}
        <p className="cart-line__price">
          {formatPrice(productPrice)}
        </p>
        {hasSale && (
          <div className="cart-line__sale">
            <span>{formatPrice(originalPrice)}</span>
            <strong>-{salePercentage}%</strong>
          </div>
        )}
        <div className="cart-line__actions">
          <button
            type="button"
            onClick={() => onUpdateQuantity(item.id, Math.max(1, quantity - 1))}
            style={QUANTITY_BUTTON_STYLE}
          >
            -
          </button>
          <span>{quantity}</span>
          <button
            type="button"
            onClick={() => onUpdateQuantity(item.id, quantity + 1)}
            style={QUANTITY_BUTTON_STYLE}
          >
            +
          </button>
          <Button variant="danger" style={REMOVE_BUTTON_STYLE} onClick={() => onRemove(item.id)}>
            {t('cart.remove')}
          </Button>
        </div>
      </div>
      <div className="cart-line__total">
        <p style={{ fontSize: '20px', fontWeight: 'bold' }}>
          {formatPrice(itemTotal)}
        </p>
      </div>
    </div>
  );
};

export default CartItem;
